export default __webpack_public_path__ + "static/media/gif coviello.6d4e16d6.gif";